// extracted by mini-css-extract-plugin
export default {"container":"styles_container__+W9BT","title":"styles_title__ILJEK","txt":"styles_txt__QscC0"};